export default __webpack_public_path__ + "static/media/5_4.0db0f661.png";